import { render, staticRenderFns } from "./currentScore.vue?vue&type=template&id=bf92bef8&scoped=true&"
import script from "./currentScore.vue?vue&type=script&lang=js&"
export * from "./currentScore.vue?vue&type=script&lang=js&"
import style0 from "./currentScore.vue?vue&type=style&index=0&id=bf92bef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf92bef8",
  null
  
)

export default component.exports